import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const FileUploadButtonWrapper = styled.label`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 38px;
  max-width: 100%;
  text-align: center;
  cursor: pointer;
  border: 1px dashed #ccc;
  padding: 8px;
  border-radius: 8px;
  background-color: #ffffff;
  transition: background-color 0.3s;
  gap: 16px;
  cursor: pointer;
  &:hover {
    background-color: #f0f0f0;
  }
`;

export const FileUploadButtonWrapperSmall = styled.label`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  min-height: 38px !important;
  min-width: 38px !important;
  text-align: center;
  cursor: pointer;
  border: 1px solid #ccc;
  padding: 8px;
  border-radius: 8px;
  background-color: #ffffff;
  transition: background-color 0.3s;
  gap: 7px;
  cursor: pointer;
  &:hover {
    background-color: #f0f0f0;
  }
`;

export const FileUploadIcon = styled.div`
  font-size: 20px;
  margin-bottom: 5px;
`;

export const ContainerFiles = styled.div`
  display: flex;
  flex-direction: row;
  gap: 7px;
  flex-wrap: wrap;
`;

export const FileUploadText = styled.div`
  color: #646363;
  text-align: right;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  max-width: 150px;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
  overflow: hidden;
  cursor: pointer;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
`;

export const File = styled.button`
  display: flex;
  flex-direction: row;
  height: 38px;
  max-width: 200px;
  align-items: center;
  justify-content: center;
  border: 1px solid #ccc;
  padding: 5px 4px 5px 16px;
  border-radius: 8px;
  background-color: #ffffff;
  gap: 4px;

  :hover .DeleteButtonWrapper {
    display: block;
  }
`;

export const DeleteButtonWrapper = styled.div``;

export const DeleteButton = styled.button`
  background-color: red;
  color: white;
  border: none;
  padding: 5px 10px;
  cursor: pointer;
`;

export const ContainerWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  justify-content: space-between;
  gap: 7px;
`;
